import React, { useContext, useEffect } from 'react';
import { TravelBotLogoImage } from '../../TravelBotLogoImage';
import { ChatMessage, Text } from 'pcln-design-system';
import MessageFooter from '../MessageFooter/MessageFooter';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import { mapManager } from '../Maps/googleMapManager';
import { useChatUIContext } from '../../hooks/useChatUIContext';
import { mapPinType } from '../../constants';
import { expressDealHotelId } from '../../HotelComponent/useSetHotelPinOnMapHook';
import analytics from '../../analytics/analytics';
import { InlineLocationLink } from './InlineLocationLink';
import { InlineCitationLink } from './InlineCitationLink';
import { CitationsSources } from './CitationsSources';
import { marked } from 'marked';
function getMarkdownText(text) {
  try {
    return marked.parse(text);
  } catch (e) {
    return text;
  }
}
export const TextWithInlineMetadataComponent = React.memo(props => {
  const {
    displayableInlineContents,
    metadataCollection,
    webSearchResult = []
  } = props;
  const {
    appendNewPinToList,
    hotelOnMapList
  } = useContext(ChatbotDataContext);
  const {
    setIsMapOpened
  } = useChatUIContext();
  const googlePin = metadataCollection.filter(pin => pin.type !== 'CITATION');
  const citationsMeta = metadataCollection.filter(pin => pin.type === 'CITATION');
  useEffect(() => {
    appendNewPinToList({
      listOfPins: googlePin
    });
  }, []);
  function handleMapButtonClick(pinsInCurrentLine, targetPin) {
    if ((targetPin === null || targetPin === void 0 ? void 0 : targetPin.type) === mapPinType.HOTEL && (targetPin === null || targetPin === void 0 ? void 0 : targetPin.hotelId)) {
      // Find hotel result from existing hotel result
      const hotelPin = hotelOnMapList === null || hotelOnMapList === void 0 ? void 0 : hotelOnMapList.find(p => {
        var _a;
        const hotel = p === null || p === void 0 ? void 0 : p.hotel;
        if ((hotel === null || hotel === void 0 ? void 0 : hotel.hotelType) === 'SOPQ') {
          const expressId = expressDealHotelId(hotel);
          return expressId === targetPin.hotelId;
        } else {
          return String((_a = p === null || p === void 0 ? void 0 : p.hotel) === null || _a === void 0 ? void 0 : _a.hotelId) === String(targetPin.hotelId);
        }
      });
      // If hotel result is found, open hotel detail page
      if (hotelPin && (hotelPin === null || hotelPin === void 0 ? void 0 : hotelPin.hotelDetailURL)) {
        analytics.log({
          label: 'HotelSearchResult',
          hotelId: hotelPin.hotelId,
          message: 'HOTEL_DETAIL_LINK_CLICKED',
          clickedOnPennMessage: 'Y'
        });
        window.open(hotelPin.hotelDetailURL, '_blank');
        return;
      }
    } else {
      setIsMapOpened(true);
      mapManager.addCallback(() => {
        mapManager.fitBoundsOnCurrentMap(pinsInCurrentLine).catch(() => {});
      });
    }
  }
  return React.createElement(ChatMessage, {
    ml: '',
    mb: 4,
    variation: 'initial',
    Icon: TravelBotLogoImage,
    message: React.createElement(React.Fragment, null, displayableInlineContents.map((content, ci) => {
      if (Array.isArray(content)) {
        const allPinMetaInThisLine = content.filter(c => {
          var _a;
          return typeof c === 'object' && (c === null || c === void 0 ? void 0 : c.metadata) && ((_a = c === null || c === void 0 ? void 0 : c.metadata) === null || _a === void 0 ? void 0 : _a.type) !== 'CITATION';
        });
        const pinsInCurrentLine = allPinMetaInThisLine.map(m => m.metadata);
        return React.createElement(React.Fragment, {
          key: `array-content-${ci}`
        }, React.createElement(Text, {
          mb: 1
        }, content.map((c, cii) => {
          var _a;
          if (typeof c === 'string') {
            return React.createElement(React.Fragment, {
              key: `meta-content-${cii}`
            }, React.createElement(Text.span, {
              mb: 1
            }, c));
          } else if (c === null || c === void 0 ? void 0 : c.metadata) {
            if (((_a = c === null || c === void 0 ? void 0 : c.metadata) === null || _a === void 0 ? void 0 : _a.type) === 'CITATION') {
              const citationMeta = c === null || c === void 0 ? void 0 : c.metadata;
              return React.createElement(InlineCitationLink, {
                key: `meta-content-${cii}`,
                metadata: citationMeta
              });
            }
            const googlePinMeta = c === null || c === void 0 ? void 0 : c.metadata;
            return React.createElement(InlineLocationLink, {
              key: `meta-content-${cii}`,
              pinsInCurrentLine: pinsInCurrentLine,
              googlePinMeta: googlePinMeta,
              handleMapButtonClick: handleMapButtonClick,
              metadata: googlePinMeta
            });
          }
        })));
      } else if (content) {
        return React.createElement(React.Fragment, {
          key: `text-content-${ci}`
        }, React.createElement(Text, {
          mb: 1,
          //@ts-ignore
          dangerouslySetInnerHTML: {
            __html: getMarkdownText(content)
          }
        }));
      }
    }), (citationsMeta === null || citationsMeta === void 0 ? void 0 : citationsMeta.length) > 0 && React.createElement(CitationsSources, {
      citationsMeta: citationsMeta,
      webSearchResult: webSearchResult
    })),
    footer: React.createElement(MessageFooter, null)
  });
});
TextWithInlineMetadataComponent.displayName = 'InlineMetadataComponent';